import React, { Component } from "react";

class CategoryTable extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <table className="a-table">
        <thead>
          <tr>
            <td>Category</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          {this.props.categories.length > 0 &&
            this.props.categories.map(c => (
              <tr key={c.category_id} id={`row${c.category_id}`}>

                <td>
                  <div className="input-wrapper" style={{ width: 350, display: 'inline-block' }}>
                    <input type="text"
                      placeholder="Add category"
                      onChange={this.onChange}
                      className={`ad-category-input cat-ad-${c.category_id}`}
                      defaultValue={c.category} />
                    <div class="input-wrapper">
                      <div className="LoginFormCheckboxWrapper pull-left">
                        <label>Click to make it visible to admin only</label>
                        <input type="checkbox" value="true" name="visibility" 
                          className={`update-category-visibility-${c.category_id}`} />
                      </div>
                    </div>

                    <button
                      className={`a-table-retrieve`}
                      style={{ marginTop: "15px", marginLeft: -555, borderRadius: 3 }}
                      data-id={c.category_id}
                      onClick={this.props.update}
                    >
                      Update
                  </button>
                  </div>
                </td>
                <td>
                  <button
                    className={`a-table-delete`}
                    data-id={c.category_id}
                    onClick={this.props.delete}
                  >
                    {`Delete`}
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    );
  }
}

export default CategoryTable;
